/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */

export type TrainingAgentSessionViewStatus =
  (typeof TrainingAgentSessionViewStatus)[keyof typeof TrainingAgentSessionViewStatus];

export const TrainingAgentSessionViewStatus = {
  starting: "starting",
  idle: "idle",
  working: "working",
  approval: "approval",
  ended: "ended",
  failed: "failed",
} as const;
